import { graphql } from "@/gql";

export const addThreadNoteMutation = graphql(`
  mutation AddThreadNote(
    $thread_id: String!
    $body: String
    $file_paths: [String!]
  ) {
    addThreadNote(thread_id: $thread_id, body: $body, file_paths: $file_paths) {
      ...ThreadMessageFields
    }
  }
`);
